import {agencyServerArticleNumber, agencyServerCMSArticles, agencyServerShopArticles, cmsArticles, shopArticles} from "../config/Config";

export const isAgencyServer = (articleNumber) => {
    return ("" + articleNumber) === agencyServerArticleNumber;
}

export const isConfigurableArticle = (articleNumber) => {
    if (!articleNumber) {
        return false;
    }
    return [
        ...cmsArticles,
        ...shopArticles
    ].indexOf("" + articleNumber) >= 0;
}

export const isNextcloudArticle = (articleNumber) => {
    return ("" + articleNumber) === "70009"
}

export const isAgencyServerCMSArticle = (articleNumber) => {
    return agencyServerCMSArticles.indexOf("" + articleNumber) >= 0;
}

export const isAgencyServerShopArticle = (articleNumber) => {
    return agencyServerShopArticles.indexOf("" + articleNumber) >= 0;
}

export const isAgencyServerDevProjectArticle = (articleNumber) => {
    return "" + articleNumber === "72002";
}

export const isNonUsualArticleType = (articleType) => {
    return ["dsgvo", "solr", "varnish"].includes(articleType)
}

export const isHighscaleAgencyServerArticle = (articleNumber) => {
    return ["72117", "72118", "72119", "72225", "72226", "72227"].includes('' + articleNumber);
}



/** WEBPACK FOOTER **
 ** ./src/selectors/ArticleNumbers.js
 **/